// --- COMPONENTS ---

const routes = [
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/components/pages/Terms.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/components/pages/Privacy.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/meetings',
    name: 'Meetings',
    component: () => import('@/components/pages/MeetingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Meeting',
    path: '/meetings/:meetingId',
    component: () => import('@/components/pages/Meeting/MeetingPage.vue'),
    meta: {
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: '/shared/meetings/:shareToken',
    name: 'Shared Meeting',
    component: () => import('@/components/pages/SharedMeeting.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/team',
    name: 'TeamStats',
    component: () => import('@/components/pages/TeamStats/TeamStatsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/account',
    component: () => import('@/components/pages/Settings/ProfileEditPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/notifications',
    component: () => import('@/components/pages/Settings/Notifications.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/teams/:teamId',
    component: () => import('@/components/pages/Settings/Teams/TeamSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/teams',
    component: () => import('@/components/pages/Settings/Teams/TeamsSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/topics',
    component: () => import('@/components/pages/Settings/TopicsSettings/TopicsSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/ai-templates',
    component: () => import('@/components/pages/Settings/AiTemplatesSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/ai-templates',
    component: () => import('@/components/pages/Settings/AiTemplatesSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/edit',
    component: () => import('@/components/pages/Settings/OrganizationEditPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/billing',
    component: () => import('@/components/pages/Settings/BillingSettingsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organization/ai-templates/:aiTemplateId',
    component: () => import('@/components/pages/Settings/AiTemplatesSettingsPageQuestions.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/components/pages/Settings/Settings.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/playlists/:playlistId',
    name: 'Highlight',
    component: () => import('@/components/pages/PlaylistPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/playlists',
    name: 'Playlists',
    component: () => import('@/components/pages/PlaylistsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/insights',
    name: 'Insights',
    component: () => import('@/components/pages/Chat/ChatPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/components/pages/Notifications/Notifications.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('@/components/pages/CalendarPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/onboarding/members',
    component: () => import('@/components/pages/Onboarding/InviteMembersPage.vue'),
    meta: {
      hideFooter: true,
      requiresAuth: true,
    },
  },
  {
    path: '/settings/organizations/invite',
    name: 'Organization',
    component: () => import('@/components/pages/Settings/SettingsInviteMembersPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/components/pages/Login.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/components/pages/ForgotPasswordPage.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/i/:inviteId',
    name: 'Invited',
    component: () => import('@/components/pages/Onboarding/Invited.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/activate/:inviteId',
    component: () => import('@/components/pages/Onboarding/ActivateAccountPage.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/v0/activate/:inviteId',
    component: () => import('@/components/pages/Onboarding/DeprecatedActivateAccountPage.vue'),
    meta: {
      hideFooter: true,
      hideDrawer: true,
    },
  },
  {
    path: '/admin',
    component: () => import('@/components/pages/SuperUser/SuperUserPanelPage.vue'),
    meta: {
      requiresSuperUser: true,
    },
  },
  {
    path: '/speech-sample',
    component: () => import('@/components/pages/SpeechSampleRecordPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    redirect: '/meetings',
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/pages/404.vue'),
    meta: {},
  },
  {
    path: '/integrations/record',
    name: 'IntegrationRecord',
    component: () => import('@/components/pages/IntegrationsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default routes;
